import { Grid } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { GItem } from '../grids'
import { UnitTitle } from './unitTitle'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'
import { memberModifyChildFamilyHospitalUrl } from '../../../../containers/common/constant/appUrl'

export const CATEGORY_NAMES = ['familyHospital', 'familyHospitalTel']

interface ChildFamilyHospitalUnitProps {
  child?: Child
  sectionLabel: string
  categoryMst?: GetCategoryMstDto[]
  hideLink?: boolean
}

export const ChildFamilyHospitalUnit = (props: ChildFamilyHospitalUnitProps) => {
  const { categoryMst, child, sectionLabel } = props
  if (child == null || categoryMst == null || categoryMst.length === 0) return null
  
  const targetCategories = categoryMst?.filter((value) => CATEGORY_NAMES.includes(value.category))
  if (targetCategories == null || targetCategories.length === 0) return null
  
  const categoryMap: {[key:string]: GetCategoryMstDto} = {}
  targetCategories?.forEach(e => categoryMap[e.category] = e)
  
  return (
    <>
      <UnitTitle title={sectionLabel} linkTo={memberModifyChildFamilyHospitalUrl.url(child.childId)} operationLog={{ operationId: OperationId.OP_00000189 }} hideLink={props.hideLink} />
      <Grid container>
        
        {isNoData(child) 
          ? <GItem xs={12}>{'登録なし'}</GItem>
          : targetCategories.map((c, i) => {
            return (<DataRow
              key={`familyHospital${i}`}
              category={c}
              child={child}
            />)
          })
        }
      </Grid>
    </>
  )
}

interface DataRowProps {
  category: GetCategoryMstDto
  child: Child
}

const DataRow = ({ category, child }: DataRowProps) => {
  const key = category.category as keyof Child
  const label = category.altCategoryName ?? category.name
  return (
    <>
      {label != null && label !== '' &&
        <GItem xs={2.5} md={1}>{label}</GItem>
      }
      <GItem xs={9.5} md={11}>{child[key]}</GItem>
    </>
  )
}

const isNoData = (child: Child) => {
  return !CATEGORY_NAMES.some(cn => child[cn as keyof Child] != null && child[cn as keyof Child] !== '')
}